
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

interface StrategyTypeFilterProps {
  selectedTypes: ("premium" | "free")[];
  onToggle: (type: "premium" | "free") => void;
}

const StrategyTypeFilter = ({ selectedTypes, onToggle }: StrategyTypeFilterProps) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-bold text-[#1B2F47] block">
        Strategy Type
      </Label>
      <div className="flex gap-2">
        <Button
          variant="ghost"
          size="sm"
          className={`flex-1 h-10 rounded-md text-sm ${
            selectedTypes.includes("premium")
              ? "bg-[#F6C528] text-[#012846] hover:bg-[#F7D44C] font-semibold"
              : "bg-[#3D99FC] text-white hover:bg-[#2d89ec] active:bg-[#1d79dc]"
          }`}
          onClick={() => onToggle("premium")}
        >
          PREMIUM
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className={`flex-1 h-10 rounded-md text-sm ${
            selectedTypes.includes("free")
              ? "bg-[#607D9B] text-white hover:bg-[#506d8b] active:bg-[#40607b]"
              : "bg-[#3D99FC] text-white hover:bg-[#2d89ec] active:bg-[#1d79dc]"
          }`}
          onClick={() => onToggle("free")}
        >
          FREE
        </Button>
      </div>
    </div>
  );
};

export default StrategyTypeFilter;
